import { render, staticRenderFns } from "./ExpandableCards.vue?vue&type=template&id=e61d41a4&scoped=true&"
import script from "./ExpandableCards.vue?vue&type=script&lang=js&"
export * from "./ExpandableCards.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableCards.vue?vue&type=style&index=0&id=e61d41a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61d41a4",
  null
  
)

export default component.exports